if (!customElements.get('brew-reserve-form')) {
  customElements.define(
    'brew-reserve-form',
    class BrewReserveForm extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.product-farm__reserve-input');
        this.button = this.querySelector('.product-farm__reserve-button');
        this.message = this.querySelector('.product-farm__reserve-message');
        if (!this.input || !this.button) return;
        this.button.addEventListener('click', this.onSubmit.bind(this));
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.onSubmit();
          }
        });
      }

      onSubmit() {
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        const email = this.input.value.trim();
        this.input.value = email;
        if (!email || !this.input.checkValidity()) {
          this.input.reportValidity();
          return;
        }

        const companyId = this.dataset.companyId;
        const listId = this.dataset.listId;
        if (!companyId || !listId) {
          this.setMessage(this.dataset.errorMessage || 'Something went wrong. Please try again.', true);
          return;
        }

        this.setMessage();
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('is-loading');

        const headers = {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2025-10-15',
        };

        const profileBody = JSON.stringify({
          data: {
            type: 'profile',
            attributes: {
              email,
              properties: {
                reserved: '0',
              },
            },
          },
        });

        const subscriptionBody = JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Reserve form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties: {
                      reserved: '0',
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        });

        Promise.all([
          fetch(`https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(companyId)}`, {
            method: 'POST',
            headers,
            body: profileBody,
          }),
          fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
            method: 'POST',
            headers,
            body: subscriptionBody,
          }),
        ])
          .then((responses) => {
            const succeeded = responses.every((response) => response.ok);
            if (!succeeded) throw new Error('Klaviyo request failed');

            if (this.dataset.redirectUrl) {
              window.location.assign(this.dataset.redirectUrl);
              return;
            }

            this.button.classList.remove('is-loading');
            this.button.removeAttribute('aria-disabled');
          })
          .catch(() => {
            this.setMessage(this.dataset.errorMessage || 'Something went wrong. Please try again.', true);
            this.button.classList.remove('is-loading');
            this.button.removeAttribute('aria-disabled');
          });
      }

      setMessage(text, isError) {
        if (!this.message) return;
        this.message.toggleAttribute('hidden', !text);
        this.message.textContent = text || '';
        this.message.classList.toggle('is-error', Boolean(isError));
      }
    }
  );
}
